import { render, staticRenderFns } from "./CategoryStepsReorder.vue?vue&type=template&id=bd48ca16&scoped=true&"
import script from "./CategoryStepsReorder.vue?vue&type=script&lang=js&"
export * from "./CategoryStepsReorder.vue?vue&type=script&lang=js&"
import style0 from "./CategoryStepsReorder.vue?vue&type=style&index=0&id=bd48ca16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd48ca16",
  null
  
)

export default component.exports